import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ItemList from '../../../Item-List';
import { Kanban } from 'libs/kanban';

const Area = ({
  id,
  name: initialName,
  setItems,
  index,
  isNew,
  setSelectedItem,
  setIsOpenModalDelete,
  setStatus,
}) => {
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const seo = new Kanban('seo', accountParam);
  const [name, setName] = useState(initialName);

  const addArea = async () => {
    const response = await seo.createTypeItem('areas', { name });

    return {
      id: response.id,
      name,
      isNew: false,
    };
  };

  const updateArea = async () => {
    return await seo.updateTypeItem('areas', id, {
      id,
      name,
    });
  };

  return (
    <ItemList
      id={id}
      initialName={initialName}
      name={name}
      setName={setName}
      setItems={setItems}
      index={index}
      isNew={isNew}
      setSelectedItem={setSelectedItem}
      setIsOpenModalDelete={setIsOpenModalDelete}
      setStatus={setStatus}
      addItem={addArea}
      updateItem={updateArea}
      textSaveButton="Add area"
    />
  );
};

Area.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  setItems: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isNew: PropTypes.bool,
  setSelectedItem: PropTypes.func.isRequired,
  setIsOpenModalDelete: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default Area;
